import * as React from 'react';
import * as styles from './Item.css';
import { clsx } from 'clsx';
import { UIText1, UIText2 } from '@cian/ui-kit';
import { TReliableParamType } from '../../../types/developerV2/reliability';

export interface IReliabilityItemProps {
  iconType: TReliableParamType;
  title: string;
  label?: string;
}

export const Item = (props: IReliabilityItemProps) => {
  return (
    <li className={clsx(styles['item'], styles[props.iconType])}>
      <div className={styles['content']}>
        <UIText1>{props.title}</UIText1>
        <UIText2 color={'gray40_100'}>{props.label}</UIText2>
      </div>
    </li>
  );
};
